function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _ from 'lodash';
var inference = {
  uid: '',
  name: '',
  rotation: {},
  expectedY: false,
  predictedY: false,
  confidences: {},
  img: '',
  display: false,
  selected: false
};

var correctInferences = function correctInferences(batch) {
  return _.filter(batch, function (inference) {
    return inference.expectedY === inference.predictedY;
  });
};

export var batchScore = function batchScore(batch) {
  return correctInferences(batch).length / batch.length * 100;
};
export var hiddenInferences = function hiddenInferences(state) {
  return _.filter(state, {
    display: false
  });
};

var visibleInferences = function visibleInferences(state) {
  return _.filter(state, {
    display: true
  });
};

var deselect = function deselect(item) {
  return _objectSpread(_objectSpread({}, item), {}, {
    selected: false
  });
};

var select = function select(item) {
  return _objectSpread(_objectSpread({}, item), {}, {
    selected: true
  });
};

var displayImage = function displayImage(item) {
  return _objectSpread(_objectSpread({}, item), {}, {
    display: true
  });
};

export var cmQuadrantSelector = function cmQuadrantSelector(state, expected, predicted) {
  return _.filter(visibleInferences(state), {
    expectedY: expected,
    predictedY: predicted
  });
};

var inferences = function inferences() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'ADD_INFERENCE':
      var payload = action.payload;
      return [].concat(_toConsumableArray(state), [_objectSpread(_objectSpread({}, inference), {}, {
        uid: payload.uid,
        name: payload.name,
        rotation: payload.rotation,
        expectedY: payload.expectedY,
        predictedY: payload.predictedY,
        confidences: payload.confidences,
        img: payload.img,
        display: false
      })]);

    case 'DISPLAY_INFERENCES':
      return hiddenInferences(state).map(displayImage);

    case 'SELECT_INFERENCE':
      return state.map(function (inference) {
        if (inference.uid === action.inference.uid) {
          return select(inference);
        }

        return deselect(inference);
      });

    default:
      return state;
  }
};

export default inferences;